import React from 'react';
interface Option {
  value: string;
  label: string;
}
interface TabsProps {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  label: string;
}
export function SegmentedToggle({
  options,
  value,
  onChange,
  label
}: TabsProps) {
  return <div role="tablist" aria-label={label} className="flex items-center gap-2" data-id="element-423" data-mp="2bqgel46m6ulp">
      {options.map(option => {
      const active = option.value === value;
      return <button key={option.value} type="button" role="tab" aria-selected={active} onClick={() => onChange(option.value)} className={`rounded-md px-3 py-1.5 text-[13px] transition-colors ${active ? 'bg-brand-50 font-medium text-brand-600' : 'text-ink-700 hover:bg-ink-50'}`} data-id="element-424" data-mp="21w7lae9rexmh">
            {option.label}
          </button>;
    })}
    </div>;
}
export function UnderlineTabs({
  options,
  value,
  onChange,
  label
}: TabsProps) {
  return <div role="tablist" aria-label={label} className="flex gap-5 border-b border-ink-200" data-id="element-425" data-mp="2fpyjbpc0i9zl">
      {options.map(option => {
      const active = option.value === value;
      return <button key={option.value} type="button" role="tab" aria-selected={active} onClick={() => onChange(option.value)} className={`-mb-px border-b-2 pb-2 text-[13px] transition-colors ${active ? 'border-brand-600 font-medium text-brand-600' : 'border-transparent text-ink-800 hover:text-ink-900'}`} data-id="element-426" data-mp="2ppfng2bm8ftg">
            {option.label}
          </button>;
    })}
    </div>;
}
export function PillTabs({
  options,
  value,
  onChange,
  label
}: TabsProps) {
  return <div role="tablist" aria-label={label} className="flex items-center gap-1" data-id="element-427" data-mp="1e8pnv21p6m8t">
      {options.map(option => {
      const active = option.value === value;
      return <button key={option.value} type="button" role="tab" aria-selected={active} onClick={() => onChange(option.value)} className={`rounded-md px-3 py-1.5 text-[13px] transition-colors ${active ? 'bg-ink-100 font-medium text-ink-900' : 'text-ink-700 hover:bg-ink-50'}`} data-id="element-428" data-mp="39dyq8ac4xdyj">
            {option.label}
          </button>;
    })}
    </div>;
}